import { Component, input, output } from '@angular/core';
import { ButtonClickEvent, CacButtonComponent } from "@controladad/ng-base";

@Component({
  selector: 'app-export-button',
  imports: [CacButtonComponent],
  templateUrl: './export-button.component.html',
})
export class ExportButtonComponent {
  permission = input<string | undefined>(undefined);
  export = output<ButtonClickEvent>();
}
